import React from 'react';
import "../../../styles/DefenceStyles/DefenceOverview.css"
// Images
import gpsImage from '../../.../../../assets/images/Defence/Overview/defence.png';
// import defenceImage from '../../assets/images/Defence/defence2.png';
// import breakoutImage from '../../assets/images/Defence/defence3.png';

const Hero = () => {
  return (
    <section className="defence-hero">
      <div className="defence-container">
        {/* LEFT CONTENT */}
        <div className="defence-left">
          <h1>
            Defense & Strategic
            <br />
            Electronic Solutions
          </h1>

          <p>
            Indigenous, secure, and mission-critical electronics for
            weapon systems and defence platforms
          </p>

          <div className="defence-features">
            <div className="feature">
              <div className="feature-icon">
                <i className="bi bi-shield-lock"></i>
              </div>
              <span>Indigenous Engineering</span>
            </div>

            <div className="feature">
              <div className="feature-icon">
                <i className="bi bi-patch-check"></i>
              </div>
              <span>Defence-Grade Confidentiality</span>
            </div>

            <div className="feature">
              <div className="feature-icon">
                <i className="bi bi-lightning-charge"></i>
              </div>
              <span>Mission-Critical Reliability</span>
            </div>
          </div>

        </div>

        {/* RIGHT IMAGES */}
        <div className="defence-right">
          {/* GPS FAN OUT UNIT */}
          <div className="image-box-one img-top">
            <img
              src={gpsImage}
              alt="GPS Fan Out Unit"
            />
          </div>

          {/* BREAKOUT BOX
          <div className="image-box-two img-middle">
            <img
              alt="Breakout Box Interface Panel"
            />
          </div>

          {/* CABLE ASSEMBLY */}
          {/* <div className="image-box-three img-bottom">
            <img
              alt="Rugged Cable Assembly"
            />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Hero;
